import { Component, Input } from '@angular/core';
import { DateFormatType, camelCaseToPascalCase } from '@core';
import { IHistorique } from '@core-lib/models/history.model';

@Component({
    selector: 'history',
    templateUrl: './history.component.html',
    styles: [],
    standalone: false
})
export class HistoryComponent {
	@Input() selectedHistorique: IHistorique[];
	dateFormatType = DateFormatType;

	public firstLetterCapitalize(value: string): string {
		return camelCaseToPascalCase(value);
	}
}
